var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"container-fluid px-0"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6"},[_c('WssUrl'),_c('Faucet',{staticClass:"mt-3"})],1),_c('div',{staticClass:"col-12 col-md-6"},[_c('LastLedger')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }